import * as React from 'react';
import { Alert, Row, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';

const CircleSpinner = (
  <LoadingOutlined
    style={{
      fontSize: 24,
    }}
    spin
  />
);

export default function LoadingData() {
  const location = useLocation();
  const pageName = location.pathname.split('/')[1];

  return (
    <Row justify='center' align='middle' className='mg-top-30'>
      <Alert
        message={`Fetching ${pageName} data please wait`}
        type={'warning'}
      />
      <div
        className={
          ' txt-center data-loader-image ' +
          ' mg-top-20 mg-bottom-20 mg-left-0 mg-right-0 ' +
          ' pd-top-30 pd-bottom-30 pd-right-50 pd-left-50 '
        }
      >
        <Spin indicator={CircleSpinner} />
      </div>
    </Row>
  );
}
